import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateProjectDates } from '@/features/projects/project-details/api/update-project-dates';
import { useToast } from '@/shared/hooks/use-toast';

export const useUpdateProjectDates = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });

  return useMutation({
    mutationFn: updateProjectDates,
    onSuccess: () => {
      queryClient.invalidateQueries();
      toast({ title: t('project_dates_saved') });
    },
    onError: () => {
      toast({
        title: t('project_dates_error'),
        variant: 'destructive',
      });
    },
  });
};
